import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  addVideo,
  checkIfDuplicateExists,
} from "../../firebase/fireStoreServices";
import BulkUploadData from "./BulkUploadData";

export default function VideoAdminForm() {
  const [videoData, setVideoData] = useState({
    id: "",
    title: "",
    thumbnail: "",
    url: "",
  });

  const handleChange = (event) => {
    setVideoData({ ...videoData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const isDuplicate = await checkIfDuplicateExists("videos", {
        title: videoData.title,
        url: videoData.url,
        thumbnail: videoData.thumbnail,
      });
      if (isDuplicate) {
        alert("This video is already present in the database!");
        return;
      } else {
        await addVideo(videoData);
        alert("Video added successfully!");
        setVideoData({
          id: "",
          title: "",
          thumbnail: "",
          url: "",
        });
      }
    } catch (error) {
      console.error("Error adding Video: ", error);
      alert("Failed to add Video");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{ mt: 5, p: 4, bgcolor: "#f9f9f9", borderRadius: 3, boxShadow: 3 }}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Video Admin Form
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Video ID"
                name="id"
                fullWidth
                value={videoData.id}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Title"
                name="title"
                fullWidth
                value={videoData.title}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Thumbnail URL"
                name="thumbnail"
                fullWidth
                value={videoData.thumbnail}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Video URL"
                name="url"
                fullWidth
                value={videoData.url}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="secondary">
                Add Video
              </Button>
            </Grid>
          </Grid>
        </form>
        <Divider sx={{ mt: 3 }} />
        <BulkUploadData collectionName="videos" uploadService={addVideo} />
      </Box>
    </Container>
  );
}
